import { FC } from 'react';

import { LinkField, TextField } from '@sitecore-jss/sitecore-jss-react';

import { TipCardContainer } from '@custom-components/InspirationAdviceFilter';
import { useTranslation } from '@i18n';
import { Box, Heading, Text, TextLink } from '@sparky';

import { TipCardSkeleton } from './TipCard.skeleton';

interface Props {
  heading: string;
  link?: LinkField;
  isLoading?: boolean;
  text?: TextField['value'];
}

export const TipCard: FC<Props> = ({ heading, link, isLoading, text }) => {
  const { t } = useTranslation();

  if (isLoading) return <TipCardSkeleton />;

  return (
    <TipCardContainer backgroundColor="backgroundVarFour" padding="6" borderRadius="m" data-testid="card">
      <Heading as="h3" size="S">
        {heading}
      </Heading>
      <Box paddingTop="3" paddingBottom="3">
        <Text>{text}</Text>
      </Box>
      {link && link.value.href && (
        <TextLink emphasis="high" href={link.value.href}>
          {link.value.text || t('generalLabels.readMore')}
        </TextLink>
      )}
    </TipCardContainer>
  );
};
